<template>
	<div class="container">
		<div class="row" v-if="this.data.show_title">
			<h3>{{ this.data.title }}</h3>
		</div>
		<div class="row g-3">
			<partner-card v-for="(partner, index) in data.data.items"
						  :key="index"
						  :data="partner"
						  class="col-12"
						  :class="itemSize"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {PageComponentInterface} from "../Interfaces/PageComponentInterface";
import PartnerCard from "../../../Components/Partners/PartnerCard.vue";

export default defineComponent({
	name: "PartnersPageSection",
	components: {PartnerCard},
	computed: {
		itemSize() {
			const quantity = this.data.data.quantity ?? 4;
			const classSize = Math.floor(12 / quantity);
			return quantity == 8 ? `col-lg` : `col-lg-${classSize}`;
		}
	},
	props: {
		data: {
			type: Object as PropType<PageComponentInterface>,
			required: true,
		}
	},
});
</script>

<style scoped>
</style>
